import { MVPD_PREVIOUS_KEY, BAM_PAYWALL_IFRAME_ID } from 'constants';
import { AuthTypes } from 'enums';
import { isStreamStatus } from 'lib/auth';
import {
    createAndPerformStartAuthenticationAction,
    createDisplayProviderDialogAction,
    createDTCPaywallAction
} from 'common/actions/authenticationActions';
import { get } from 'lib/util/localStorage';

export function fetchTVEAuthAction(dispatch, nextSelectedContent, stream) {
    dispatch(createAndPerformStartAuthenticationAction({
        content: nextSelectedContent,
        stream
    }))
    .then((isAuthenticated) => {
        if (!isAuthenticated) {
            return dispatch(createDisplayProviderDialogAction());
        }
    });
}
/**
 * Single stream authentication rules
 * 1. if stream is upcoming or stream requires DTC, show DSS paywall
 * 2. if stream requires MVPD or ISP, 'tve is passed in query string, or
      MVPD_PREVIOUS_KEY is set in localStorage
 * 3. if 1 and 2 conditions are not met, show DSS paywall
 *
 * @param {args}   object list of requiredAuths, nextSelectedContent, query and dispatch 
   requiredAuths - Array containing all authTypes for the stream
   nextSelectedContent - Parent object containing the selected content with streams array
   query - React Router query object containing all possible query params
   dispatch - redux store dispatch
 */
export async function handleSingleStreamAuthentication(args) {
    const { requiredAuths, nextSelectedContent, query={}, dispatch, stream } = args;
    const chooseTVEAuth = (query.auth === 'tve');
    const userHasAuthedMVPD = get(MVPD_PREVIOUS_KEY);

    if (requiredAuths.every(authType => authType === AuthTypes.BAM) || isStreamStatus(stream, 'upcoming')) {
        dispatch(createDTCPaywallAction({
            containerId: BAM_PAYWALL_IFRAME_ID,
            content: nextSelectedContent,
            stream
        }));
    } else if (requiredAuths.every(authType => (authType === AuthTypes.MVPD || authType === AuthTypes.ISP)) ||
        chooseTVEAuth || userHasAuthedMVPD) {
            fetchTVEAuthAction(dispatch, nextSelectedContent, stream);
    } else {
        dispatch(createDTCPaywallAction({
            containerId: BAM_PAYWALL_IFRAME_ID,
            content: nextSelectedContent,
            stream
        }));
    }
};



// WEBPACK FOOTER //
// ./app/lib/streamPicker/handleSingleStreamAuthentication.js